import TenCheckbox from '../checkbox';
import TenRadio from '../radio';
import TenButton from '../button';
import tableCellMixin from './table-cell-mixin';
import { getValueByPath, isFunction } from '../scripts/utils/helper';

const TYPE = ['selector', 'expand'];

export default {
  name: 'table-body-cell',
  inject: ['table'],
  mixins: [tableCellMixin],
  props: {
    column: {
      type: Object,
      default: () => {},
    },
    row: {
      type: Object,
      default: () => {},
    },
    rowIndex: Number,
    colIndex: Number,
    expanded: Boolean,
  },
  computed: {
    selectorChecked() {
      return !!this.table.selectedRowKeys.find(key => key === this.rowKey);
    },
    rowKey() {
      return this.table.getRowKey(this.row);
    },
    className() {
      const { align } = this.column;
      return [
        'ten-table__table-cell',
        {
          [`ten-table__table-cell--align-${align}`]: align,
          'ten-table__table-cell--invisible': this.invisible,
          'first-child': this.colIndex === 0,
        },
      ];
    },
    tdProps() {
      const { row, column: { tdProps }, rowIndex } = this;
      let props;
      if (typeof tdProps === 'function') {
        props = tdProps(row, rowIndex);
      } else if (typeof tdProps === 'object') {
        props = tdProps;
      }
      return props || {};
    },
  },
  render(h) {
    const { row, column, rowIndex, tdProps } = this;
    const { renderCell, render, type, rowSpan, colSpan } = column;

    let content;

    if (TYPE.indexOf(type) > -1) {
      content = this[`render${type.replace(/^[a-z]/, letter => letter.toUpperCase())}`](h);
    } else if (renderCell && typeof renderCell === 'function') {
      content = renderCell({ row, column, $index: rowIndex });
    } else {
      content = typeof render === 'function' ? render(h, { row, column, $index: rowIndex }) : getValueByPath(row, render);
    }

    const rs = this.spanHandler(rowSpan, rowIndex, row, column);
    const cs = this.spanHandler(colSpan, rowIndex, row, column);

    const hide = rs === 0 || cs === 0;

    let td;
    if (hide) {
      td = null;
    } else if (this.invisible) {
      td = (
        <td
          class={this.className}
          colspan={cs}
          rowspan={rs}
          { ...tdProps }
        ></td>
      );
    } else {
      td = (
        <td
          class={this.className}
          colspan={cs}
          rowspan={rs}
          { ...tdProps }
        >
          {content}
        </td>
      );
    }

    return td;
  },
  methods: {
    renderSelector(h) { // eslint-disable-line
      const Selector = this.column.selectType === 'radio' ? TenRadio : TenCheckbox;
      return (
        <Selector
          onChange={this.onSelectorChange}
          checked={this.selectorChecked}
          disabled={!this.isSelectable()}
        />
      );
    },
    onSelectorChange(checked) {
      let selectedKeys = this.table.selectedRowKeys;

      if (this.column.selectType === 'radio') {
        if (checked) {
          selectedKeys = [this.rowKey];
        }
      } else {
        if (checked) {
          selectedKeys = this.table.selectedRowKeys.concat(this.rowKey);
        } else {
          selectedKeys = this.table.selectedRowKeys.filter(v => v !== this.rowKey);
        }
      }
      this.table.changeSelected(selectedKeys);
    },
    renderExpand() {
      return (
        <TenButton
          class="expand"
          theme="text"
          icon-only
          icon={this.expanded ? 'remove' : 'add'}
          size="small"
          onClick={this.onExpandToggle}
        />
      );
    },
    onExpandToggle() {
      if (typeof this.rowKey === 'undefined') {
        console.warn(`当前数据未发现 ${this.table.rowKey} 字段，请提供 rowKey 属性.`);
      }
      if (this.expanded) {
        this.table.$emit('update:expandedRowKeys', this.table.expandedRowKeys.filter(key => key !== this.rowKey));
      } else {
        this.table.$emit('update:expandedRowKeys', this.table.expandedRowKeys.concat(this.rowKey));
      }
    },
    spanHandler(fn, ...args) {
      if (typeof fn !== 'function') return 1;
      const span = Number(fn(...args));
      return isNaN(span) ? 1 : span;
    },
    isSelectable() {
      return isFunction(this.column.selectable) ? this.column.selectable(this.rowIndex, this.row) : true;
    },
  },
};
